import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import App from './App';

// Evita re-render do React enquanto o usuario ainda esta digitando a data.
// Sem isso, preencher dia+mes dispara onChange, re-renderiza o componente
// e o campo perde o foco antes do usuario terminar de digitar o ano.
document.addEventListener('input', (e) => {
  const t = e.target;
  if ((t.type === 'date' || t.type === 'datetime-local') && !t.value) {
    e.stopPropagation();
  }
}, true); // capture=true => roda antes dos handlers do React

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => console.log('[SW] Registrado:', reg.scope))
      .catch((err) => console.warn('[SW] Falha ao registrar:', err));
  });
}
